// services/project/ProjectService.ts
import { BaseService } from "@services/BaseService";
import { ProjectOverview } from "@shared/interfaces/ProjectsFiles";

class ProjectService extends BaseService {
  create(data: Partial<ProjectOverview>) {
    return this.post("/projects/create", data);
  }

  getProjectById(projectId: string) {
    return this.get(`/projects/${projectId}/`);
  }

  getMyProjects(params: {
    offset?: number;
    limit?: number;
    order?: string;
    tab?: string;
  }) {
    return this.get("/projects/my_projects", { params, withCredentials: true });
  }

  getProjects(params: {
    offset?: number;
    limit?: number;
    order?: string;
    tab?: string;
  }) {
    return this.get("/projects", { params, withCredentials: true });
  }

  getSharedProjects(params: {
    offset?: number;
    limit?: number;
    order?: string;
  }) {
    return this.get("/projects/shared_projects", {
      params,
      withCredentials: true,
    });
  }

  deleteProject(projectId: string) {
    return this.delete(`/projects/${projectId}/`);
  }

  updateProject(projectId: string, data: Partial<ProjectOverview>) {
    return this.patch(`/projects/${projectId}`, data);
  }

  getProjectMembers(projectId: string) {
    return this.get(`/projects/${projectId}/get_members`);
  }
  getSharedProject(sharedToken: string) {
    return this.get(`/projects/p/${sharedToken}/`);
  }
  getCountries() {
    return this.get("/projects/countries");
  }
  getDashboardInfo() {
    return this.get("/projects/dashboard-info");
  }
  grantRole(projectId: string, email: string, roleId: number) {
    return this.post(`/projects/${projectId}/grant_role/`, {
      email,
      role_id: roleId,
    });
  }
  revokeRole(projectId: string, memberId: number) {
    return this.post(`/projects/${projectId}/revoke_role/`, null, {
      params: { member_id: memberId },
    });
  }
  toggleProjectPublicAccess(projectId: string, isPublic: boolean) {
    return this.post(`/projects/${projectId}/public?is_public=${isPublic}`);
  }

  getProjectsDropdown(query: string) {
    return this.get(`/projects/dropdown`, {
      params: { query },
    });
  }
}

export const projectService = new ProjectService();
